const NO_SCREENSHOTS_COPY = 'No screenshots yet'

export default NO_SCREENSHOTS_COPY
